export default __webpack_public_path__ + "static/media/lunch4.f1bef622.jpeg";